import { EventEmitter } from 'events';
import assign from 'object-assign';
import AdminConstants from 'constants/AdminConstants';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';

const ActionTypes = AdminConstants.ActionTypes;
const CHANGE_EVENT = 'DRAYAGE_DATA_UPDATE';

let filters = {};
let sharedFilter = {};
let error = {};
let drayageData = {};

const FiltersStore = assign({}, EventEmitter.prototype, {
  emitChange(payload) {
    this.emit(CHANGE_EVENT, payload);
  },
  emitFiltersChange(payload) {
    this.emit('FILTER_UPDATE', payload);
  },
  emitError(payload) {
    this.emit('FILTER_CRUD_ERROR', payload);
  },
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
  removeFiltersChangeListener(callback) {
    this.removeListener('FILTER_UPDATE', callback);
  },
  removeErrorListener(callback) {
    this.removeListener('FILTER_CRUD_ERROR', callback);
  },
  addErrorListener(callback) {
    this.on('FILTER_CRUD_ERROR', callback);
  },
  addFiltersChangeListener(callback) {
    this.on('FILTER_UPDATE', callback);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },
  getDrayageData() {
    return drayageData;
  },
  setDrayageData(data) {
    const update = [];
    const add = [];

    data.docChanges().forEach((change) => {
      const { type, doc } = change;
      switch (type) {
        case 'added': {
          const addedData = doc.data();
          addedData.docId = doc.id;
          add.push(addedData);
          break;
        }
        case 'modified': {
          const removedData = doc.data();
          removedData.docId = doc.id;
          update.push(removedData);
          break;
        }
        default: {
          console.log('the default type pinged');
          break;
        }
      }
    });

    drayageData = {
      add,
      update,
    };
  },
  deleteFilter(id) {
    let i = -1;
    filters.forEach((filter, k) => {
      if (id === filter._id) i = k;
    });
    filters.splice(i, 1);
  },
  addFilter(data) {
    filters.push(data);
  },
  getFilters() {
    return filters;
  },
  setFilters(data) {
    filters = data;
  },
  setError(e) {
    error = e;
  },
  getErrorMsg() {
    return error;
  },
});

FiltersStore.dispatchToken = AdminAppDispatcher.register((payload) => {
  const action = payload.action;
  const { result } = action;

  switch (action.type) {
    case ActionTypes.FILTERS_FAILURE:
      FiltersStore.setError(result);
      FiltersStore.emitError(FiltersStore.getErrorMsg());
      break;
    case ActionTypes.GET_ALL_FILTERS_SUCCESS:
      FiltersStore.setFilters(result);
      FiltersStore.emitFiltersChange({
        filters: FiltersStore.getFilters(),
        event: 'GET',
      });
      break;
    case ActionTypes.FILTER_CREATED:
      FiltersStore.addFilter(result);
      FiltersStore.emitFiltersChange({
        filters: FiltersStore.getFilters(),
        event: 'CREATED',
        result,
      });
      break;
    case ActionTypes.FILTER_DELETED:
      FiltersStore.deleteFilter(result);
      FiltersStore.emitFiltersChange({
        filters: FiltersStore.getFilters(),
        event: 'DELETED',
      });
      break;
    default:
      break;
  }
});

export default FiltersStore;
